module.exports = __webpack_public_path__ + "img/16.577a123c.jpg";